var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    staticClass: "my-20px my-md-40px",
    attrs: {
      "elevation": "0"
    }
  }, [_c('v-card-title', {
    staticClass: "tit tit--sm primary--text pt-0"
  }, [_c('span', [_vm._v("캐시리워드 이용안내")])]), _c('v-card-text', [_c('ul', {
    staticClass: "disc-list"
  }, [_vm._l(_vm.items, function (item, index) {
    return [_c('li', {
      key: index,
      domProps: {
        "innerHTML": _vm._s(item)
      }
    })];
  })], 2)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }